import { getGenplan } from './getGenplan';
import { IAppState } from '../../common/state';

export function getIsGenplanAvailable(state: IAppState): boolean {
  return Boolean(getGenplan(state));
}
